module.exports = __webpack_public_path__ + "cm-logo-blue.jpg";